<script lang="ts">
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import { Badge } from "@getprovi/craft-svelte";

  import type { OrderGroup } from "@shared/types/OrderGroup";
  import type { RetailerDistributor } from "@shared/types/RetailerDistributor";

  export let orderGroup: OrderGroup;
  export let aooDistributors: RetailerDistributor[];
  export let setActionCompleted: () => void;

  const formatDistributorNames = () => {
    if (aooDistributors.length === 1) {
      return aooDistributors[0].distributor.name;
    } else if (aooDistributors.length === 2) {
      return `${aooDistributors[0].distributor.name} and ${aooDistributors[1].distributor.name}`;
    } else {
      return aooDistributors
        .map((d, index) => {
          if (index < aooDistributors.length - 1) {
            return `${d.distributor.name}, `;
          } else {
            return `and ${d.distributor.name}`;
          }
        })
        .join("");
    }
  };

  let distributorNames = formatDistributorNames();
  let badgeLabel =
    aooDistributors.length > 1
      ? `${aooDistributors.length} ${pluralize("Order", aooDistributors.length)} Not Sent`
      : "Order Not Sent";
</script>

<style lang="scss">
  .aoo-action-required-card {
    max-width: 604px;
    border-radius: 24px;
  }
  .rounded {
    border-radius: 32px;
  }
</style>

<div
  class="fizz-card fizz-bordered fizz-inset-square-16 aoo-action-required-card fizz-margin-auto craft"
>
  <Badge variant="critical" label={badgeLabel} class="fizz-stack-12" />
  <h2
    class="fizz-stack-8"
    class:fizz-heading-2={$LayoutStore.isDesktop}
    class:fizz-heading-4={$LayoutStore.isMobile}
  >
    Additional Action Needed to Send {pluralize("Order", aooDistributors.length)}
  </h2>
  <p
    class="fizz-stack-8"
    class:fizz-text-large={$LayoutStore.isDesktop}
    class:fizz-text-medium={$LayoutStore.isMobile}
  >
    Check your email <strong>{window["$rootScope"].user?.email}</strong> for the next steps to send
    your {pluralize("order", aooDistributors.length)} for {distributorNames}.
  </p>
  <div class="fizz-flex-row fizz-justify-end">
    <button
      class="fizz-button fizz-button fizz-button-primary rounded"
      class:fizz-flex-item={$LayoutStore.isMobile}
      on:click={setActionCompleted}
    >
      I Understand
    </button>
  </div>
</div>
